import { render, staticRenderFns } from "./ArchiveCardView.vue?vue&type=template&id=75f36a7a&scoped=true"
import script from "./ArchiveCardView.vue?vue&type=script&lang=js"
export * from "./ArchiveCardView.vue?vue&type=script&lang=js"
import style0 from "./ArchiveCardView.vue?vue&type=style&index=0&id=75f36a7a&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "75f36a7a",
  null
  
)

export default component.exports